import type {Breakpoints, Layout, ResponsiveLayouts} from "react-grid-layout";
import type {WidgetDto, WidgetLayout} from "../../../../generated/api/base";

export type HomeDashboardBreakpoint = "lg" | "md" | "sm" | "xs" | "xxs";

export const HOME_DASHBOARD_BREAKPOINTS: Breakpoints<HomeDashboardBreakpoint> = {
	lg: 1200,
	md: 996,
	sm: 768,
	xs: 480,
	xxs: 0,
};

export const HOME_DASHBOARD_COLUMNS: Breakpoints<HomeDashboardBreakpoint> = {
	lg: 12,
	md: 10,
	sm: 6,
	xs: 4,
	xxs: 2,
};

export const HOME_DASHBOARD_MARGIN = [16, 16] as const;

export const getHomeDashboardWidgetKey = (widget: WidgetDto, index: number): string => widget.dashboardWidgetID ?? String(index);

export const createHomeDashboardLayouts = (
	widgets: readonly WidgetDto[],
	widgetLayoutsMaybe: readonly WidgetLayout[] | null | undefined,
): ResponsiveLayouts<HomeDashboardBreakpoint> => {
	const widgetLayoutsById = new Map<string | undefined, WidgetLayout>();

	for (const widgetLayout of widgetLayoutsMaybe ?? []) {
		if (!widgetLayoutsById.has(widgetLayout.dashboardWidgetID)) {
			widgetLayoutsById.set(widgetLayout.dashboardWidgetID, widgetLayout);
		}
	}

	const largeLayout: Layout = widgets.map((widget, index) => {
		const widgetLayout = widgetLayoutsById.get(widget.dashboardWidgetID);

		return {
			i: getHomeDashboardWidgetKey(widget, index),
			x: widgetLayout?.column ?? 0,
			y: widgetLayout?.row ?? 0,
			w: widgetLayout?.width ?? 1,
			h: widgetLayout?.height ?? 1,
			static: true,
		};
	});

	// The native responsive grid derives the smaller breakpoint layouts from the
	// largest available layout, matching the legacy component's behavior.
	return {lg: largeLayout};
};
